import { apiClient } from '~/api/client';
import { endpoints } from '~/api/endpoints';

import type {
  CreateSubsidiaryPayload,
  Subsidiary,
  UpdateSubsidiaryPayload,
} from '../types/subsidiary.types';

/**
 * List current user's subsidiaries (GET /subsidiaries).
 */
export async function listSubsidiaries(): Promise<Subsidiary[]> {
  const res = await apiClient
    .get(endpoints.subsidiaries.list())
    .json<Subsidiary[] | { data: Subsidiary[] }>();
  return Array.isArray(res) ? res : res.data;
}

/**
 * Create a new subsidiary (POST /subsidiaries).
 * Requires { name, slug, organizationId }.
 */
export async function createSubsidiary(payload: CreateSubsidiaryPayload): Promise<Subsidiary> {
  return apiClient.post(endpoints.subsidiaries.create(), { json: payload }).json<Subsidiary>();
}

/**
 * Update a subsidiary's name/domain (PATCH /subsidiaries/:id). Allowed for
 * owners/admins of that subsidiary; status changes stay super-admin only.
 */
export async function updateSubsidiary(
  id: string,
  payload: UpdateSubsidiaryPayload,
): Promise<Subsidiary> {
  return apiClient.patch(endpoints.subsidiaries.update(id), { json: payload }).json<Subsidiary>();
}
